import { Link } from "react-router-dom";

export const links = [
  { to: "/", label: "Home", slug: "home" },
  { to: "/about", label: "About", slug: "about" },
  { to: "/work", label: "Portfolio", slug: "portfolio" },
  { to: "/blog", label: "AI Journey", slug: "ai-journey" },
  { to: "/resume", label: "Resume", slug: "resume" },
  { to: "/contact", label: "Contact", slug: "contact" },
];

export function DesktopNav({ pathname }) {
  return (
    <div className="hidden md:flex items-center gap-9">
      {links.map((l) => (
        <Link
          key={l.to}
          to={l.to}
          data-testid={`nav-link-${l.slug}`}
          className={`nav-underline text-xs font-bold uppercase tracking-[0.12em] transition-colors duration-200 hover:text-[var(--brand-primary)] ${
            pathname === l.to ? "nav-active text-[var(--brand-primary)]" : "text-[var(--brand-heading)]"
          }`}
        >
          {l.label}
        </Link>
      ))}
      <Link
        to="/book"
        data-testid="nav-cta-button"
        className="bg-[var(--brand-primary)] text-[var(--brand-cream)] px-6 py-2.5 rounded-full text-xs font-bold uppercase tracking-[0.1em] transition-all duration-300 hover:bg-[var(--brand-primary-dark)]"
      >
        Book a call
      </Link>
    </div>
  );
}

export function MobileMenu() {
  return (
    <div className="md:hidden bg-[var(--brand-cream)] border-t border-[#D8CEBE] px-6 py-6 flex flex-col gap-5">
      {links.map((l) => (
        <Link
          key={l.to}
          to={l.to}
          data-testid={`mobile-nav-link-${l.slug}`}
          className="text-sm font-bold uppercase tracking-[0.12em] text-[var(--brand-heading)] hover:text-[var(--brand-primary)]"
        >
          {l.label}
        </Link>
      ))}
      <Link
        to="/book"
        data-testid="mobile-nav-cta-button"
        className="bg-[var(--brand-primary)] text-[var(--brand-cream)] px-6 py-3 rounded-full text-xs font-bold uppercase tracking-[0.1em] text-center"
      >
        Book a call
      </Link>
    </div>
  );
}
